// Prevent forms from being submitted more than once
$('form').submit(e => {
  $(e.currentTarget).find('[type=submit]').not('.prevent-disable').prop('disabled', true);
});
